import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

class NgRecaptcha3Service {
    constructor() {
        this.baseUrl = 'https://www.google.com/recaptcha/api.js';
        this.siteKey = '';
        this.isLoaded = false;
        window['ngRecaptcha3Loaded'] = () => {
            this.isLoaded = true;
        };
        this.scriptId = +(new Date());
    }
    getToken(action) {
        try {
            return window['grecaptcha'].execute(this.siteKey, action);
        }
        catch (e) {
            return new Promise((resolve, reject) => {
                reject(e);
            });
        }
    }
    init(siteKey) {
        return new Promise((resolve, reject) => {
            if (this.isLoaded) {
                resolve('success');
                return;
            }
            else {
                this.siteKey = siteKey;
                const script = document.createElement('script');
                script.innerHTML = '';
                script.src = this.baseUrl + `?render=${this.siteKey}&onload=ngRecaptcha3Loaded`;
                script.id = `recapthcha-${this.scriptId}`;
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    resolve('success');
                };
                script.onerror = () => {
                    reject('error');
                };
                document.head.appendChild(script);
            }
        });
    }
    destroy() {
        this.isLoaded = false;
        const script = document.getElementById(`recapthcha-${this.scriptId}`);
        if (script) {
            script.remove();
        }
        const badge = document.getElementsByClassName('grecaptcha-badge')[0];
        if (badge) {
            badge.remove();
        }
    }
}
NgRecaptcha3Service.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgRecaptcha3Service, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NgRecaptcha3Service.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgRecaptcha3Service, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgRecaptcha3Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of ng-recaptcha3
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgRecaptcha3Service };
